(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cordial-email-signup"] && !Shopify.designMode) return;
  try {
    class CordialEmailSignup extends HTMLElement {
    #boundHandleSubmit = this.#handleSubmit.bind(this);
    #boundHandleInvalid = this.#handleInvalid.bind(this);

    connectedCallback() {
      this.form?.addEventListener('submit', this.#boundHandleSubmit);
      // `invalid` doesn't bubble, so listen in the capture phase.
      this.form?.addEventListener('invalid', this.#boundHandleInvalid, true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.#boundHandleSubmit);
      this.form?.removeEventListener('invalid', this.#boundHandleInvalid, true);
    }

    // Analytics: native constraint validation blocks the submit event entirely,
    // so a rejected email never reaches #handleSubmit. Report it as a
    // form-validation site_error (same errorType as the contact and free-gift
    // forms). `invalid` fires once per failing field, so the messages from one
    // submit attempt are collected and reported as a single error.
    #invalidMessages = null;

    #handleInvalid(event) {
      const message = event.target?.validationMessage || 'Newsletter signup validation failed';
      if (this.#invalidMessages) {
        this.#invalidMessages.push(message);
        return;
      }
      this.#invalidMessages = [message];
      queueMicrotask(() => {
        const errorMessage = this.#invalidMessages.join('; ');
        this.#invalidMessages = null;
        document.dispatchEvent(
          new CustomEvent('ea:site-error', { detail: { errorType: 'form-validation', errorMessage } })
        );
      });
    }

    get form() {
      return this.querySelector('[ref="form"]');
    }

    get emailInput() {
      return this.querySelector('[ref="emailInput"]');
    }

    get errorMsg() {
      return this.querySelector('[ref="errorMsg"]');
    }

    get successMsg() {
      return this.querySelector('[ref="successMsg"]');
    }

    get submitButton() {
      return this.querySelector('[ref="submitButton"]');
    }

    get consentContainer() {
      return this.querySelector('[ref="consentContainer"]');
    }

    get successIcon() {
      return this.querySelector('[ref="successIcon"]');
    }

    #hideMessages() {
      this.errorMsg?.classList.add('is-hidden');
      this.successMsg?.classList.add('is-hidden');
    }

    #showError() {
      this.#hideMessages();

      const { errorMsg } = this;
      if (errorMsg) {
        errorMsg.classList.remove('is-hidden');
        errorMsg.focus();
      }
    }

    async #handleSubmit(event) {
      event.preventDefault();

      const { form, emailInput, successMsg, submitButton, consentContainer, successIcon } = this;

      if (!form || !emailInput || !form.checkValidity()) {
        form?.reportValidity();
        return;
      }

      this.#hideMessages();

      const email = emailInput.value.trim();

      try {
        if (typeof crdl !== 'function') {
          console.warn('[Cordial] crdl() is not available. Ensure the Cordial app is installed.');
          this.#showError();
          return;
        }

        crdl(
          'contact',
          { email },
          {
            channels: {
              email: {
                subscribeStatus: 'subscribed',
              },
            },
            entry_source: this.dataset.entrySource,
          }
        );

        emailInput.value = email;
        emailInput.readOnly = true;
        if (successMsg) emailInput.setAttribute('aria-describedby', successMsg.id);
        submitButton?.classList.add('is-hidden');
        consentContainer?.classList.add('is-hidden');
        successIcon?.classList.remove('is-hidden');
        if (successMsg) {
          successMsg.classList.remove('is-hidden');
          successMsg.focus();
        }

        // Analytics: fire form_complete only on a successful subscribe.
        // Dispatched from the form element so the dataLayer can detect the
        // form's location (footer vs page) at runtime.
        // EA-4411: no raw or hashed email is attached — Segment identity is
        // the theme UUID / customer_id only (see assets/ea-datalayer.js).
        form.dispatchEvent(
          new CustomEvent('ea:form-submitted', {
            bubbles: true,
            detail: {
              formName: 'newsletter-signup',
              optInProperty: this.dataset.entrySource || 'footer-newsletter',
            },
          })
        );
      } catch (err) {
        console.warn('[Cordial] Email signup error:', err);
        this.#showError();
      }
    }
  }

  if (!customElements.get('cordial-email-signup')) {
    customElements.define('cordial-email-signup', CordialEmailSignup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this._drawer = this;
      this._closeBtn = this.querySelector('[data-mobile-close]');
      this._applyBtn = this.querySelector('[data-mobile-apply]');
      this._isMobile = () => window.innerWidth < 1024;
      this._zendeskModule = null;

      const externalToggle = document.querySelector('[data-mobile-filter-toggle]');
      externalToggle?.addEventListener('click', () => this.openDrawer());
      this._closeBtn?.addEventListener('click', () => this.closeDrawer());

      this.querySelectorAll('[data-filter-link]').forEach((link) => {
        link.addEventListener('click', (e) => {
          if (!this._isMobile()) return;
          e.preventDefault();

          const isActive = link.dataset.active === 'true';
          link.dataset.active = isActive ? 'false' : 'true';

          const icon = link.querySelector('[data-check-icon]');
          icon.classList.toggle('--active');
        });
      });

      this.querySelectorAll('[data-price-link]').forEach((link) => {
        link.addEventListener('click', (e) => {
          if (!this._isMobile()) return;
          e.preventDefault();

          const isActive = link.dataset.active === 'true';
          link.dataset.active = isActive ? 'false' : 'true';

          const icon = link.querySelector('[data-check-icon]');
          icon.classList.toggle('--active');
        });
      });

      this._applyBtn?.addEventListener('click', () => {
        const baseUrl = this._applyBtn.dataset.collectionUrl;
        const url = new URL(baseUrl, window.location.origin);

        const sortRadio = this.querySelector('[data-mobile-sort]:checked');
        if (sortRadio) {
          url.searchParams.set('sort_by', sortRadio.value);
        }

        this.querySelectorAll('[data-filter-link][data-active="true"]').forEach((link) => {
          url.searchParams.append(link.dataset.paramName, link.dataset.paramValue);
        });

        const activePrices = this.querySelectorAll('[data-price-link][data-active="true"]');
        const priceRanges = [];
        activePrices.forEach((pl) => {
          priceRanges.push({
            gte: pl.dataset.priceGte ? parseInt(pl.dataset.priceGte, 10) : 0,
            lte: parseInt(pl.dataset.priceLte, 10),
          });
        });

        this.closeDrawer();

        if (priceRanges.length > 0) {
          document.dispatchEvent(
            new CustomEvent('collection:navigate', {
              detail: { url: url.toString(), priceRanges },
            }),
          );
        } else {
          document.dispatchEvent(
            new CustomEvent('collection:navigate', {
              detail: { url: url.toString() },
            }),
          );
        }
      });

      this.querySelectorAll('[data-filter-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.closest('[data-filter-group]');
          const list = group.querySelector('[data-filter-list]');
          const icon = btn.querySelector('[data-toggle-icon]');
          const isHidden = list.hidden;
          list.hidden = !isHidden;
          icon.classList.toggle('--active', isHidden);
        });
      });

      this.querySelectorAll('[data-show-more]').forEach((wrapper) => {
        wrapper.addEventListener('click', () => {
          const group = wrapper.closest('[data-filter-group]');
          const items = group.querySelectorAll('[data-overflow-item]');
          const label = wrapper.querySelector('button');
          const expanded = wrapper.dataset.expanded === 'true';

          items.forEach((item) => item.classList.toggle('tw-hidden', expanded));
          wrapper.dataset.expanded = expanded ? 'false' : 'true';
          if (label) label.textContent = expanded ? (wrapper.dataset.labelShowAll || 'Show all') : (wrapper.dataset.labelShowLess || 'Show less');
        });
      });
    }

    openDrawer() {
      this._drawer?.classList.add('--mobile-active');
      this._toggleChatWidget(true);
    }

    closeDrawer() {
      this._drawer?.classList.remove('--mobile-active');
      this._toggleChatWidget(false);
    }

    // The mobile filter drawer is a full-screen overlay, so hide the Zendesk
    // launcher while it's open — mirroring the header menu and bundle drawer.
    // This compiled bundle is a classic script (a static import would break it),
    // so we dynamically import the shared module. The bare specifier resolves via
    // the importmap to the SAME module instance the header uses, so its
    // source-counted hide/restore stays consistent across overlays.
    _toggleChatWidget(hide) {
      this._zendeskModule ||= import('@theme/zendesk-launcher');
      this._zendeskModule
        .then((mod) => {
          if (hide) {
            mod.hideZendeskLauncher('collection-filters');
          } else {
            mod.restoreZendeskLauncher('collection-filters');
          }
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }
  } catch(e) { console.error(e); }
})();

})();
